// Import the functions you need from your installed npm packages
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration (from the code you sent me)
const firebaseConfig = {
  apiKey: "AIzaSyBV95yNp0MDrUId9IXOx5cLuUYaIkEj07I",
  authDomain: "newsletter-9126f.firebaseapp.com",
  projectId: "newsletter-9126f",
  storageBucket: "newsletter-9126f.firebasestorage.app", // Corrected this line, Firebase uses .app not .com
  messagingSenderId: "601449932952",
  appId: "1:601449932952:web:ac3d0948087bf0dfe748ed",
  // We don't need measurementId for Firestore, so it's removed for clarity
};

// Initialize this SECOND Firebase app with a unique name
// This is the most important step to avoid conflicts!
const newsletterApp = initializeApp(firebaseConfig, "newsletterApp");

// Get a Firestore instance for this specific app
const newsletterDb = getFirestore(newsletterApp);

// Export the database instance so your components can use it
export { newsletterDb };